const MASTERCLASS_REGISTRATION_AND_CLASS_STATUS = {
  OPEN: 'Registrations Open',
  CLOSED: 'Registrations Closed',
  CLASS_STARTED: 'Masterclass Started',
  CLASS_ENDED: 'Masterclass Ended',
};

interface Registration {
  startDate: string;
  endDate: string;
}

const getRegistrationStatus = (registration: Registration | undefined): string => {
  let registrationStatus = '';
  if (registration && Object.keys(registration).length) {
    const currentDate = new Date();
    if (currentDate < new Date(registration?.startDate)) {
      registrationStatus = MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.OPEN;
    } else if (
      currentDate > new Date(registration?.startDate) &&
      currentDate < new Date(registration?.endDate)
    ) {
      registrationStatus = MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.CLASS_STARTED;
    } else if (currentDate >= new Date(registration?.endDate)) {
      registrationStatus = MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.CLASS_ENDED;
    } else {
      registrationStatus = MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.OPEN;
    }
  }

  return registrationStatus;
};

export { MASTERCLASS_REGISTRATION_AND_CLASS_STATUS, getRegistrationStatus };
